export const background = {
    height: "100vh",
    backgroundImage: `url(/images/bg_page.png)`
}